import React from "react";
import Surname from "./Surname";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>
            © {currentYear} S. <Surname />. All rights reserved.
          </p>
          <div className="footer-links">
            <a
              href="https://github.com/s-cafferty-nlp"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              GitHub
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
